export default "__VITE_ASSET__aRD3Hfmu__"